import { render, staticRenderFns } from "./mid.vue?vue&type=template&id=667c85b5"
import script from "./mid.vue?vue&type=script&lang=js"
export * from "./mid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports